import type { SVGProps } from "react";
import * as React from "react";

const SvgDribbble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.37 2.163a1 1 0 1 0-1.62 1.174zm6.248 18.542a1 1 0 0 0 1.944-.47zM19.89 5.74a1 1 0 0 0-1.52-1.3zM2.226 9.94a1 1 0 1 0 .048 2zm19.267 3.867a1 1 0 0 0 .514-1.934zm-8.683-.967-.335-.942zm-8.258 5.745a1 1 0 1 0 1.636 1.15zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm-4.25.337c2.169 2.992 3.63 5.286 4.801 7.839s2.069 5.407 3.067 9.53l1.944-.471c-1.012-4.178-1.945-7.17-3.193-9.893-1.25-2.725-2.798-5.141-5-8.179zM18.37 4.44c-3.43 4.011-8.27 5.312-16.144 5.5l.048 2c8.006-.192 13.606-1.511 17.616-6.2zm3.637 7.434c-3.65-.97-6.992-.878-9.532.024l.67 1.884c2.08-.738 4.999-.866 8.348.024zm-9.533.024c-2.831 1.01-5.413 3.115-7.922 6.687l1.636 1.15c2.351-3.348 4.63-5.123 6.958-5.953z"
    />
  </svg>
);
export default SvgDribbble;
